<template>
    <ais-instant-search :search-client="searchClient" :index-name="pagesIndex" :routing="routing">
        <ais-configure :hits-per-page.camel="24" />

        <div class="p-search__query mb-base">
            <ais-search-box placeholder="Search for…" />
        </div>

        <div class="mb-12 sm:mb-32">
            <ais-hits>
                <template slot="item" slot-scope="{ item }">
                    <ProductCard :item="item" />
                </template>
            </ais-hits>

            <ais-pagination :show-first="false" :show-last="false" @page-change="scrollTop" />
        </div>
    </ais-instant-search>
</template>

<script>
import algoliasearch from 'algoliasearch/lite';
import ProductCard from './components/ProductCard.vue';
import routing from './routing';

export default {
    name: 'PagesSearch',

    components: {
        ProductCard,
    },

    props: {
        query: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            searchClient: algoliasearch(window.algolia.id, window.algolia.key),
            routing: routing('pages_default'),
        };
    },

    computed: {
        pagesIndex() {
            return 'pages_default';
        },
    },

    methods: {
        scrollTop() {
            const el = this.$refs.search;
            el.scrollIntoView();
        },
    },
};
</script>

<style scoped>
.subitem-wrapper {
    &::before,
    &::after {
        margin: auto;
        content: '';
    }
}
</style>
